export default "__VITE_ASSET__DRqR$g3l__"